import _ from 'lodash';
import Injector from 'vue-inject';
import Debug from '@/util/debug';

const debug = Debug('service:Package');

export function fixPackageFormatFromApiMaf(p) {
  return Object.assign({}, {
    name: _.get(p, 'package', ''),
    cluster: _.get(p, 'cluster_name', ''),
    frequency: _.get(p, 'frequency', 0),
    disabled: _.get(p, 'disabled', 0),
    budget: {
      budget: _.get(p, 'budget_client', 0),
    },
    reach: {
      min: _.get(p, 'min_reach', 0),
      potential: _.get(p, 'potential_reach', 0),
    },
    impressions: {
      potential: _.get(p, 'potential_impressions', 0),
    },
    clicks: {
      min: _.get(p, 'min_clicks', 0),
      max: _.get(p, 'max_clicks', 0),
    },
    leads: {
      min: _.get(p, 'min_leads', 0),
      max: _.get(p, 'max_leads', 0),
    },
    offers: {
      min: _.get(p, 'min_offers', 0),
      max: _.get(p, 'max_offers', 0),
    },
  });
}

export default class PackageService {
  constructor(aas, genericConfigService) {
    this.genericConfigService = genericConfigService;
    this.adApiService = aas;
    this.packages = null;
  }

  loadPackagesFromApi() {
    debug.info('getting packages from api');
    return this.adApiService.getPackages()
      .then((packages) => {
        debug.info('got %d packages from API', Object.keys(packages).length);
        return packages;
      })
      .then(packages => packages.map(fixPackageFormatFromApiMaf))
      .then((packages) => packages.sort((a, b) => {
        if (a.reach.min > b.reach.min) {
          return -1;
        } else if (b.reach.min > a.reach.min) {
          return 1;
        }
        return 0;
      }))
      .then((packages) => {
        this.packages = packages.filter(p => !p.disabled);
        this.disabledPackages = packages.filter(p => p.disabled);
        return packages.filter(p => !p.disabled);
      })
      .catch((err) => {
        debug.error('error: %o', err);
      });
  }

  getAllPackages() {
    if (this.packages === null) {
      return this.loadPackagesFromApi();
    }

    return new Promise(resolve => resolve(this.packages));
  }

  getDisabledPackages() {
    if (this.packages === null) {
      return this.loadPackagesFromApi().then(() => this.disabledPackages);
    }

    return new Promise(resolve => resolve(this.disabledPackages));
  }

  getCampaignPackage(campaign, withDisabled = false) {
    return Promise.all([this.getAllPackages(), this.getDisabledPackages()])
      .then(([enabled, disabled]) => (withDisabled ? enabled.concat(disabled) : enabled))
      .then(packages => packages.find((p) => campaign.package === p.name));
  }
}

Injector.service('packageService', ['adApiService', 'genericConfigService'], PackageService);



// WEBPACK FOOTER //
// ./src/services/PackageService.js